import { Box, Flex, Stack, VStack, Text, Badge } from "@chakra-ui/react";
import { BOTTOM_LINE, CONTACT_TAB_ID } from "../scripts/config";
import "./cstyle.css"
import TabHeading from "./TabHeading";
import { useContext, useEffect, useRef } from "react";
import "./cstyle.css"
import ContactForm from "./ContactForm";
import ContactFormMobile from "./ContactFormMobile";
import StatsPostMobile from "./StatsPostMobile";
import { ScrollContext } from "../contexts/ScrollContext";

export default function GitField(){
    
    let contactRef = useRef(null)
let {page,handlePage} = useContext(ScrollContext)
    useEffect(()=>{
        if(page==CONTACT_TAB_ID){
            contactRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    },[page])

  

    return <Flex w={{base:"100%",lg:"30%"}}  overflow="scroll" direction="column" className="postField" >
         <Stack display={{lg:"none",sm:"none",base:"-webkit-inline-flex"}} alignItems={"flex-start"} margin="8px"><TabHeading  content={"Statistics"}  size={"2xl"}/></Stack>
       <StatsPostMobile />
       <VStack padding={4} position={{lg:"relative",sm:"fixed"}} alignItems="stretch" gap={4}>
        <TabHeading content={"Engineering Focus"} size={"md"} />
        <Stack p={4} borderRadius={10} border="1px solid" borderColor="gray.600" spacing={3}>
          <Text fontWeight="bold">AI-powered creative tools</Text>
          <Text fontSize="sm">Production web experiences for video, canvas, and media workflows.</Text>
          <Badge alignSelf="flex-start" colorScheme="blue">Personate.ai · Founding Team</Badge>
        </Stack>
        <Stack p={4} borderRadius={10} border="1px solid" borderColor="gray.600" spacing={3}>
          <Text fontWeight="bold">Scalable frontend systems</Text>
          <Text fontSize="sm">React and TypeScript architecture, performance tuning, async rendering, and resilient media delivery.</Text>
        </Stack>
        <Stack p={4} borderRadius={10} border="1px solid" borderColor="gray.600" spacing={3}>
          <Text fontWeight="bold">Cross-functional delivery</Text>
          <Text fontSize="sm">Hands-on collaboration with founders, product, design, and QA from planning through production.</Text>
        </Stack>
       </VStack>


       <Stack display={{lg:"none",sm:"none",base:"-webkit-inline-flex"}}  ref={contactRef} alignItems={"flex-start"} margin="8px"><TabHeading  content={"Contact"}  size={"2xl"}/></Stack>
       <Stack display={{lg:"none",sm:"none",base:"-webkit-inline-flex"}} ><TabHeading size={"md"} content={BOTTOM_LINE} /></Stack>
       <ContactFormMobile />
        
       <Box h={"90px"} width="100%"></Box>

    </Flex>
}
